import { LOGOUT, UPDATE_USER } from '../actionTypes';

const initialState = {
  userId: null,
  userToken: null,
  firstName: null,
  lastName: null,
  email: null,
  error: null,
  marketingOptin: null,
  termsAccepted: null,
};

export function sessionReducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT:
      return initialState;
    case UPDATE_USER:
      const { user } = action.payload;
      return {
        ...state,
        userId: user._id,
        userToken: user._arkkeoToken,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        marketingOptin: user.marketingOptin,
        termsAccepted: user.termsAccepted,
        error: null,
      };
    default:
      return state;
  }
}
